module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/2/4-73ec74af911b8e45b62c215c4b55b77e.jpg";